import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";

const EditCompetitionSubjectiveExamPricing = () => {
  const [competitions, setCompetitions] = useState([]);
  const [competitionsId, setCompetitionsId] = useState();
  const [price, setPrice] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const handleGoBack = () => {
    navigate("/subjective-exam-pricing");
  };
  const handleAddPrice = () => {
    navigate(
      "/subjective-exam-pricing/add-competition-subjective-exam-pricing",
    );
  };
  const handleViewAllPrice = () => {
    navigate(
      "/subjective-exam-pricing/all-competition-subjective-exam-pricing",
    );
  };

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => {
        const examCategoriesData = response.data?.data || [];
        setCompetitions(examCategoriesData);
      })
      .catch((error) => console.log(error));
  }, []);

  const payload = {
    competitionId: competitionsId,
    price: parseInt(price),
    type: "competition",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/admin/pricing/subjective-exam/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Price Updated successfully.");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while updating price.");
      });
  };

  return (
    <>
      <div id="exam-competitive-notes-inner-wrapper">
        <div className="competitive-main-header">
          <BiArrowBack
            onClick={handleGoBack}
            className="left-arrow-icon"
            style={{
              cursor: "pointer",
              marginLeft: "10px",
              fontSize: "25px",
              color: "#000", // Customize the color as needed
            }}
          />
          <div className="competitive-header-div">
            <h5>Competitive Subjective Exam Pricing</h5>

            <div className="competitive-btn-group">
              <button
                className="addNewCompetitiveNoteBtn"
                onClick={handleAddPrice}
              >
                + Add Price
              </button>
              <button
                className="viewAllCompetitiveNotesBtn"
                onClick={handleViewAllPrice}
              >
                All Price
              </button>
            </div>
          </div>

          <div className="competitive-form-container" id="form">
            <h4 className="competitive-note-detail">Edit Price</h4>
            <form
              onSubmit={handleSubmit}
              className="competitive-note-detail-form"
            >
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Exam Category</label>
                <select
                  className="new-chapter-dropdown"
                  value={competitionsId}
                  onChange={(e) => setCompetitionsId(e.target.value)}
                  required
                >
                  <option value="">-Select Category-</option>
                  {competitions.map((examCategory, idx) => (
                    <option key={idx} value={examCategory._id}>
                      {examCategory.examCategory}
                    </option>
                  ))}
                </select>
              </div>

              <div className="input-group">
                <label className="label">Price</label>
                <input
                  type="Number"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder="Enter Price"
                  required
                />
              </div>

              <div className="competitive-form-btns">
                <button className="competitive-btn-save" type="submit">
                  Save
                </button>
                <button
                  className="competitive-btn-cancel"
                  type="button"
                  onClick={() =>
                    navigate(
                      "/subjective-exam-pricing/all-competition-subjective-exam-pricing",
                    )
                  }
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCompetitionSubjectiveExamPricing;
